// amicusServiceData.js

export const serviceDummyData = [
  // MANAGEMENT CONSULTING
  {
    slug: "management-consulting",
    title: "Management Consulting",
    subTitle:
      "Driving performance through structured problem-solving, governance clarity, and execution discipline.", // [file:3]
    heroBanner: "/images/services/management-consulting/banner.webp",
    shortIntro: [
      "Management consulting focused on solving complex business challenges across strategy, operations, and governance.", // [file:3]
      "We work with leadership teams to diagnose root causes, prioritise initiatives, and translate strategy into measurable outcomes.", // [file:3]
      "Our approach combines data-driven analysis with practical execution support, ensuring decisions are not only sound on paper but effective on the ground.", // [file:3]
    ],
    serviceOverview: [
      "Management Consulting at Amicus supports leadership teams in improving profitability, operational clarity, and strategic execution.",
      "Our advisory combines financial insight, process discipline, and market understanding to help businesses make informed decisions, strengthen governance, and execute growth initiatives with consistency and control.",
    ],

    subServices: [
      {
        image: "/images/services/management-consulting/service-1.webp",
        title: "Enterprise Profitability Transformation",
        description:
          "Improves margins through structured analysis of revenue drivers, cost structures, and operational inefficiencies.", // [file:3]
      },
      {
        image: "/images/services/management-consulting/service-2.webp",
        title: "Cost Optimization Service",
        description:
          "A focused initiative to eliminate structural inefficiencies, optimize operating and overhead costs, and improve cost discipline without compromising core capabilities or long-term growth. ", // [file:3]
      },
      {
        image: "/images/services/management-consulting/service-3.webp",
        title: "Go To Market Strategy",
        description:
          "Enables effective market entry and expansion by aligning target customer segments, pricing discipline, and competitive positioning to drive sustainable and profitable growth. ", // [file:3]
      },
      {
        image: "/images/services/management-consulting/service-4.webp",
        title: "Management Review Meeting ",
        description:
          "Establishes disciplined review mechanisms to track performance, address deviations, and support timely decision-making.", // [file:3]
      },
      {
        image: "/images/services/management-consulting/service-5.webp",
        title: "Preparation of SOP",
        description:
          "This service focuses on designing clear, standardized operating procedures that streamline business processes, improve accountability, and ensure consistency in execution. SOPs are designed to enhance operational efficiency and ensure smooth, effective day-to-day business activities. ", // [file:3]
      },
    ],
    ourApproach: [
      {
        icon: "/images/services/management-consulting/approach-1.svg",
        description:
          "Detailed diagnostic of financial performance, processes, and market positioning to identify core improvement levers.", // [file:3]
      },
      {
        icon: "/images/services/management-consulting/approach-2.svg",
        description:
          "Structured recommendations translated into executable action plans with clear ownership and timelines.", // [file:3]
      },
      {
        icon: "/images/services/management-consulting/approach-3.svg",
        description:
          "Hands-on engagement with leadership teams to support implementation and change adoption.", // [file:3]
      },
      {
        icon: "/images/services/management-consulting/approach-4.svg",
        description:
          "Ongoing performance tracking through review mechanisms and management dashboards.", // [file:3]
      },
    ],
    keyBenefits: [
      "Improves profitability through disciplined cost control, pricing clarity, and execution-focused management decisions.", // [file:3]
      "Strengthens leadership alignment around priorities, accountability, and structured decision-making frameworks.", // [file:3]
      "Enhances operational efficiency by identifying process gaps and implementing sustainable performance improvements.", // [file:3]
      "Provides clear management visibility through structured reviews, metrics, and performance tracking mechanisms.", // [file:3]
      "Supports consistent execution by translating strategy into actionable, ownership-driven implementation plans.", // [file:3]
    ],
    testimonials:
      "Perspectives from leadership teams who improved execution, profitability, and decision discipline.", // [file:3]
    CTA: {
      img: "/images/services/management-consulting/cta.webp",
      description:
        "Sustainable performance requires clarity, discipline, and aligned execution. Our advisors work with leadership teams to strengthen decision-making, improve profitability, and bring structure to complex management challenges. Connect with us to elevate operational and strategic performance.", // [file:3]
    },
    FAQ: [
      {
        q: "What type of organisations benefit most from management consulting?",
        a: "Organisations facing profitability pressure, execution challenges, or leadership alignment issues benefit most from structured management consulting support.", // [file:3]
      },
      {
        q: "Is the advisory focused on strategy or execution?",
        a: "The engagement balances strategic direction with execution discipline, ensuring recommendations translate into practical, measurable business outcomes.", // [file:3]
      },
      {
        q: "How involved are leadership teams during the engagement?",
        a: "Leadership involvement is critical, as the advisory process relies on collaboration, decision ownership, and active participation throughout implementation.", // [file:3]
      },
      {
        q: "Are recommendations customised or template-based?",
        a: "All recommendations are tailored to the organisation’s structure, industry context, and operational realities rather than generic frameworks.", // [file:3]
      },
      {
        q: "How long does it take to see results from management consulting services ",
        a: "The timeline to see results depends on the complexity and scope of the challenges being addressed. Typically, clients begin to see initial improvements in performance and operational efficiency within the first few months. However, sustainable long-term results require continuous implementation and monitoring, with periodic reviews to ensure alignment with business goals and growth objectives.",
      },
    ],
  },

  // BUSINESS DIAGNOSTIC
  {
    slug: "business-diagnostic",
    title: "Business Diagnostic",
    subTitle:
      "Identifying gaps, opportunities, and priorities through structured, data-driven assessment.", // [file:3]
    heroBanner: "/images/services/business/hero.webp",
    shortIntro: [
      "Rapid, evidence-based diagnostics that reveal operational, financial, and strategic gaps hindering performance. Our analysis uncovers inefficiencies, identifies growth opportunities, and provides a clear roadmap for improvement.", // [file:3]
    ],
    serviceOverview:
      "Our Business Diagnostic service is a holistic, data-powered exploration designed to uncover hidden truths within your finance, operations, governance, and strategic direction. We illuminate performance gaps, uncover opportunities for growth, and reveal the path forward, delivering a concise report with prioritized actions and a roadmap for transformation across every function of your business. ", // [file:3]
    ourApproach: [
      {
        icon: "/images/services/business/approach-1.svg",
        description:
          "Discovery & Scoping: We initiate by understanding the key business challenges, data availability, and diagnostic objectives to align on expectations. ",
      },
      {
        icon: "/images/services/business/approach-2.svg",
        description:
          "Financial and operational review to identify inefficiencies, leakages, cost drivers, and performance bottlenecks.  ",
      },
      {
        icon: "/images/services/business/approach-3.svg",
        description:
          "Process & Organizational Deep-Dive: We evaluate workflows, governance structures, and decision-making processes to uncover areas for improvement.",
      },
      {
        icon: "/images/services/business/approach-4.svg",
        description:
          "Market & Competitor Benchmarking: By comparing your business against industry leaders, we contextualize your performance and validate your market positioning. ",
      },
      {
        icon: "/images/services/business/approach-5.svg",
        description:
          "Synthesis & Roadmap Creation: The insights derived are transformed into a prioritized action roadmap, outlining immediate wins, medium-term initiatives, and long-term improvements. ",
      },
    ],
    keyBenefits: [
      "Comprehensive visibility across key business functions identifying gaps and inefficiencies . ", // [file:3]
      "Prioritized, data-backed recommendations to help guide leadership focus and optimize resource allocation. ", // [file:3]
      "Improved financial transparency through structured analysis of revenue, margins, and cost behaviour. ", // [file:3]
      "Enable stronger decision-making with a unified view of business health. ", // [file:3]
      "Prepare your business for scaling, investment, restructuring, or transformation initiatives with a clear strategic direction. ", // [file:3]
    ],
    testimonials:
      "Insights from businesses that strengthened clarity, efficiency, and performance through structured diagnostics.  ", // [file:3]
    CTA: {
      img: "/images/services/business/cta.webp",
      description:
        "Whether you’re addressing profitability issues, evaluating performance, or planning your next growth phase, our diagnostic team helps uncover what truly drives outcomes. Connect with us to access clear insights and a focused action plan.", // [file:3]
    },
    FAQ: [
      {
        q: "How long does a Business Diagnostic take?",
        a: "Typical engagements take 4–6 weeks depending on scope. Rapid diagnostics can be delivered within 10–14 days.", // [file:3]
      },
      {
        q: "What deliverables will we receive?",
        a: "Upon completion of the diagnostic, you will receive: \n A comprehensive diagnostic report detailing key findings. \n A prioritized action roadmap that outlines short-term wins, medium-term initiatives, and long-term strategic improvements. \nA concise presentation summarizing the findings and recommendations for leadership review, ensuring clear communication of actionable insights. ", // [file:3]
      },
      {
        q: "Is this suitable for both startups and established companies?",
        a: "Yes, our Business Diagnostic service is tailored to organizations of all sizes. We customize our approach to suit the unique needs of startups and established companies, providing valuable insights and actionable recommendations at every stage of growth.", // [file:3]
      },
      {
        q: "Do you provide ongoing support after the Business Diagnostic report is delivered?",
        a: "No, we do not offer ongoing improvement services after delivering the diagnostic report. However, we provide actionable feedback across key business functions to guide your team in implementing the recommendations. For further support, we offer additional services such as Profit Enhancement Service, CFO Service , Management Review Meeting and other strategic advisory , which can be engaged separately to help drive continuous improvement.",
      },
    ],
  },

  // BUSINESS TRANSFORMATION
  {
    slug: "business-transformation",
    title: "Business Transformation",
    subTitle:
      "We help reshaping organisations for efficiency, control, and long-term scalability .Our approach empowers organizations to operate with clarity, discipline, and measurable performance, ensuring sustainable growth and long-term success",
    heroBanner: "/images/services/Business Transformation/hero.webp",
    shortIntro: [
      "Strengthening structures and processes to help organisations operate with clarity, discipline, and measurable performance.", // [file:3]
    ],
    serviceOverview:
      "At Amicus, we support businesses in scaling their operations by redesigning workflows, improving governance, and implementing systems that enhance decision-making, transparency, and profitability. Our Business Transformation service offers a bundled solution to improve efficiency, drive revenue growth, and ensure stronger governance, all in one integrated package.  ",
    ourApproach: [
      {
        icon: "/images/services/Business Transformation/approach-1.svg",
        description:
          "Organizational Assessment: We conduct a comprehensive evaluation to identify performance gaps, operational inefficiencies, and governance challenges, providing insights for targeted improvements.",
      },
      {
        icon: "/images/services/Business Transformation/approach-2.svg",
        description:
          "Transformation Blueprint: We design a comprehensive transformation plan that aligns with your strategic objectives and operational needs, focusing on growth, profitability, and governance.",
      },
      {
        icon: "/images/services/Business Transformation/approach-3.svg",
        description:
          "Implementing redesigned workflows, better reporting systems, and governance frameworks to strengthen internal controls and accountability. ",
      },
      {
        icon: "/images/services/Business Transformation/approach-4.svg",
        description:
          "Workflow Optimization: We implement streamlined workflows, robust reporting systems, and governance frameworks to strengthen internal controls and accountability.",
      },
      {
        icon: "/images/services/Business Transformation/approach-5.svg",
        description:
          "Leadership Support for Change: We guide leadership through structured change management to ensure successful transformation and long-term alignment with business goals.",
      },
      {
        icon: "/images/services/Business Transformation/approach-5.svg",
        description:
          "Ongoing Performance Tracking: With performance dashboards and milestone reviews, we monitor progress to ensure continuous improvement and adaptation.",
      },
    ],
    keyBenefits: [
      "We help you scale revenue by optimizing operations and targeting key growth areas.", // [file:3]
      "Focused strategies to improve profitability through cost optimization, efficient processes, and better decision-making.", // [file:3]
      "We strengthen governance through clear roles, responsibilities, and accountability structures, reducing risks and enhancing control.", // [file:3]
      "Streamlined workflows and decision-making processes to improve organizational performance and agility.", // [file:3]
      "Our integrated approach ensures that your business is ready for scalable growth, with systems and structures in place to support long-term success.", // [file:3]
    ],
    testimonials:
      "Success stories in business transformation, where structured transformation strengthened efficiency, governance, and performance for our clients.", // [file:3]
    CTA: {
      img: "/images/services/Business Transformation/cta.webp",
      description:
        "Unlock your business's potential with a holistic approach to transformation. From driving revenue and profitability to optimizing governance, we offer the expertise and support needed to scale effectively and sustainably. ", // [file:3]
    },
    FAQ: [
      {
        q: "How long does transformation take?",
        a: "Transformation projects typically span 1 to 3 years, depending on the organization’s size, complexity, and goals. We focus on delivering sustained, long-term results through phased, strategic execution. ", // [file:3]
      },
      {
        q: "Do you help with execution?",
        a: "Yes, we actively guide and support the execution process, ensuring the strategy is effectively implemented with hands-on involvement from our team.", // [file:3]
      },
      {
        q: "What documents are needed?",
        a: "To design an effective transformation plan, we require basic financial statements, process documentation, and relevant internal reports to assess your current operations. Additionally, we need your governance structure to evaluate decision-making frameworks and roles. Other documents such as organizational charts, performance metrics, KPIs, and previous strategic plans are also helpful to understand the operational landscape and identify areas for improvement. ",
      },
      {
        q: "Will we see immediate results from transformation?",
        a: "While some improvements are visible quickly, sustainable results take time and are seen after the implementation of redesigned processes and governance.",
      },
      {
        q: "Will the transformation impact our employees?",
        a: "The transformation process is designed to have a positive impact on employees by improving alignment, fostering collaboration, and enhancing overall engagement. We emphasize change management to ensure smooth adoption and empower employees through clear communication, training, and support throughout the transition.",
      },
    ],
  },

  // CFO SERVICES
  {
    slug: "cfo-services",
    title: "CFO Services",
    subTitle:
      "Seasoned financial leadership with over five decades of cumulative experience, delivered through flexible Virtual CFO engagements that bring clarity, control, and governance without the cost of a full-time hire.", // [file:3]
    heroBanner: "/images/services/CFO  Services/hero.png",
    shortIntro: [
      "Providing strategic financial oversight, reporting discipline, and governance support through outsourced CFO expertise.", // [file:3]
    ],
    serviceOverview:
      "Amicus provides Virtual and Fractional CFO services designed for growing businesses that need senior financial leadership without adding permanent overheads. We partner closely with promoters and leadership teams to institutionalise financial planning, build robust MIS and reporting frameworks, strengthen cash flow and working capital discipline, and enhance governance standards. Our engagement ensures investor-ready financials, sharper decision-making, and disciplined financial control, enabling founders to focus on growth while retaining confidence in financial oversight and compliance. ", // [file:3]
    ourApproach: [
      {
        icon: "/images/services/CFO  Services/approach-1.svg",
        title: "Diagnostic First:",
        description:
          "Assess the current finance function to identify gaps in reporting, cash flow visibility, controls, and governance.",
      },
      {
        icon: "/images/services/CFO  Services/approach-2.svg",
        title: "Structured Framework:",
        description:
          "Design and implement robust MIS, financial planning, cash flow management, and compliance processes tailored to the business.",
      },
      {
        icon: "/images/services/CFO  Services/approach-3.svg",
        title: "Hands-on Leadership:",
        description:
          "Act as an extension of the management team, providing senior CFO oversight along with practical execution support.",
      },
      {
        icon: "/images/services/CFO  Services/approach-4.svg",
        title: "Disciplined Review Cadence:",
        description:
          "Establish regular review mechanisms, dashboards, and management reporting for timely and informed decision-making.",
      },
      {
        icon: "/images/services/CFO  Services/approach-5.svg",
        title: "Retainer-Based Engagement:",
        description:
          "Deliver services through a structured monthly retainer model, with scope and time commitment aligned to the company’s size, complexity, and requirements.",
      },
    ],
    keyBenefits: [
      "Relieves founder and management bandwidth from day-to-day financial oversight to focus on growth and strategy. ", // [file:3]
      "Former CFO of Gati Limited and AFL/FedEx Private Limited, bringing over 30 years of proven financial leadership and governance experience. ", // [file:3]
      "Improved financial visibility through structured MIS, cash flow forecasting, and disciplined reporting. ", // [file:3]
      "Stronger governance, controls, and compliance frameworks, reducing financial and regulatory risk. ", // [file:3]
      "Enhanced readiness for IPO, investors, lenders, and board discussions through robust planning and credible reporting. ", // [file:3]
    ],
    testimonials:
      "Financial Leadership That Creates Impact How Amicus strengthened financial discipline and clarity for growing businesses.  ", // [file:3]
    CTA: {
      img: "/images/services/CFO  Services/cta.png",
      description:
        "Build financial clarity with structured reporting, robust forecasting, and governance discipline. Amicus provides flexible CFO-level expertise to help you make confident, informed decisions.", // [file:3]
    },
    FAQ: [
      {
        q: "Is the engagement remote or onsite?",
        a: "The engagement is delivered through a hybrid model, combining regular remote working with onsite interactions as required for deeper reviews, stakeholder alignment, and critical decision discussions.", // [file:3]
      },
      {
        q: "Do you replace finance teams?",
        a: "No. We work as an extension of your organization, providing senior CFO-level leadership while empowering and strengthening your existing finance team through guidance, structure, and oversight, rather than replacing in-house capabilities.", // [file:3]
      },
      {
        q: "Minimum engagement period?",
        a: "Our engagements are structured with a minimum commitment of one year. This duration allows sufficient time to assess the existing finance function, implement robust reporting and control frameworks, embed financial discipline, and deliver sustained impact rather than short-term interventions.", // [file:3]
      },
      {
        q: "Can Virtual CFO services support fundraising, debt raising, or IPO readiness?",
        a: "Yes. Our Virtual CFO services support the entire capital-raising lifecycle, including investor-ready financial models, robust MIS and reporting, due diligence preparedness, lender and investor interactions, and governance strengthening. We work closely with management to ensure financial credibility, transparency, and discipline required for fundraising, debt raising, and IPO readiness.",
      },
    ],
  },

  // IPO PROJECT MANAGEMENT
  {
    slug: "ipo-project-management",
    title: "IPO Project Management",
    subTitle:
      "Managing IPO readiness, execution, and stakeholder coordination through disciplined planning and governance.", // [file:3]
    heroBanner: "/images/services/IPO Project Management/hero.webp",
    shortIntro: [
      "End-to-end project management to take SMEs through IPO readiness and listing with disciplined timelines and stakeholder coordination.", // [file:3]
    ],
    serviceOverview:
      "We provide end-to-end IPO project management for SMEs, covering IPO planning, readiness, execution, and post-listing transition. We bring structured governance, disciplined timelines, and coordinated stakeholder management to navigate the complexities of listing with clarity and control. Our approach ensures seamless coordination across intermediaries while preparing businesses to operate as credible, compliant public companies. ", // [file:3]
    ourApproach: [
      {
        icon: "/images/services/IPO Project Management/approach-1.svg",
        description:
          "Conduct a financial readiness review to assess profitability, working capital, cash flows, reporting quality, and compliance, and recommend corrective actions to strengthen IPO preparedness.",
      },
      {
        icon: "/images/services/IPO Project Management/approach-2.svg",
        description:
          "Creation of a milestone-driven IPO roadmap aligning internal teams and external advisors efficiently.  ",
      },
      {
        icon: "/images/services/IPO Project Management/approach-3.svg",
        description:
          "Perform a company valuation analysis using appropriate methodologies and advise on funding requirements, expected valuation range, and issue pricing direction.",
      },
      {
        icon: "/images/services/IPO Project Management/approach-4.svg",
        description:
          "Support identification and negotiation with suitable merchant bankers based on sector experience, SME IPO track record, valuation credibility, and commercial terms.",
      },
      {
        icon: "/images/services/IPO Project Management/approach-5.svg",
        description:
          "Provide structured guidance on the overall IPO pathway, including process flow, timelines, intermediary roles, and key decision points. ",
      },
    ],
    keyBenefits: [
      "End-to-End IPO Ownership :Single-point accountability across the IPO lifecycle, coordinating merchant bankers, legal advisors, auditors, registrars, and regulators to ensure timelines, quality, and execution discipline. ", // [file:3]
      "Merchant Banker Selection and Fee Negotiation : Leverages strong relationships with leading merchant bankers to shortlist the right partner, negotiate competitive fee structures, and align incentives with long-term valuation rather than short-term listing optics.", // [file:3]
      "Valuation-First IPO Strategy : Provides realistic, market-anchored valuation expectations based on peer benchmarking, financial readiness, and investor appetite, ensuring promoters enter the IPO process with clarity and credibility.", // [file:3]
      "Risk Mitigation and Regulatory Discipline : Proactively identifies red flags in disclosures, related-party transactions, governance gaps, and financial presentation to minimise SEBI queries and execution delays.", // [file:3]
      "Pre-IPO Financial and Governance Readiness : Strengthens MIS, internal controls, disclosures, and governance frameworks to meet public-market standards and withstand investor and regulator scrutiny. ", // [file:3]
    ],
    testimonials:
      "Experiences from companies that achieved smooth, timely SME IPO execution.", // [file:3]
    CTA: {
      img: "/images/services/IPO Project Management/cta.webp",
      description:
        "From preparing compliance documentation to coordinating bankers, auditors, and legal teams, our IPO specialists streamline every step of your listing journey. Engage with our experts to bring structure, momentum, and clarity to your SME IPO process.", // [file:3]
    },
    FAQ: [
      {
        q: "How is IPO Project Management different from IPO advisory?",
        a: "IPO project management focuses on execution excellence, including timelines, coordination, documentation tracking, and stakeholder alignment, while IPO advisory addresses strategy, eligibility, structuring, and regulatory guidance. We deliver both services in an integrated manner, covering strategic direction as well as disciplined execution.", // [file:3]
      },
      {
        q: "How long does the IPO process take?",
        a: "SME IPO timelines typically range from 6 to 18 months, depending on the company’s readiness, complexity of preparation, and regulatory review timelines.", // [file:3]
      },
      {
        q: "What costs are involved? ",
        a: "IPO-related costs vary based on issue size, scope of work, and the mix of intermediaries involved. We provide a clear, high-level cost estimate during the initial scoping and planning phase to ensure transparency and preparedness.", // [file:3]
      },
      {
        q: "Can IPO project management help improve valuation outcomes?",
        a: "Yes. In addition to managing execution, we help nurture the business for an IPO by strengthening financials, improving reporting quality, addressing governance and compliance gaps, and aligning the company with listing requirements. This structured preparation is particularly valuable where financials are weak or criteria are not fully met, and it supports more credible and sustainable valuation outcomes.", // [file:3]
      },
    ],
  },
  // Detailed Project Report & Research Report
  {
    slug: "project-feasibility-and-strategy-report",
    title: "Detailed Project Report & Research Report",
    subTitle:
      "Evaluating viability, risk, and long-term value before capital is committed.", // [file:3]
    heroBanner: "/images/services/project-feasibility/hero.webp",
    shortIntro: [
      "Comprehensive feasibility and strategy reports that assess commercial viability, financial sustainability, execution risks, and alignment with long-term objectives. Designed to support confident decision-making before project launch.", // [file:3]
    ],
    serviceOverview:
      "Project Feasibility and Strategy Reports provide a comprehensive assessment of commercial, financial, and operational viability. The service supports decision-makers by evaluating assumptions, risks, returns, and execution considerations before committing capital or resources. ", // [file:3]
    ourApproach: [
      {
        icon: "/images/services/business/approach-1.svg",
        description:
          "Develop a clear understanding of the project concept, objectives, scale, location, and stakeholder expectations to define scope and success criteria. ", // [file:3]
      },
      {
        icon: "/images/services/business/approach-2.svg",
        description:
          "Assess market demand, industry dynamics, competitive landscape, and pricing benchmarks to validate commercial feasibility. ", // [file:3]
      },
      {
        icon: "/images/services/business/approach-3.svg",
        description:
          "Strategic assessment of market conditions, execution challenges, and scalability considerations. ", // [file:3]
      },
      {
        icon: "/images/services/business/approach-4.svg",
        description:
          "Evaluate operational requirements including capacity planning, process flows, technology options, infrastructure needs, and regulatory considerations. ", // [file:3]
      },
      {
        icon: "/images/services/business/approach-5.svg",
        description:
          "Build detailed financial models covering capital costs, operating costs, revenue assumptions, profitability, cash flows, and return metrics to assess viability. ", // [file:3]
      },
      {
        icon: "/images/services/business/approach-5.svg",
        description:
          "Identify key commercial, operational, financial, and regulatory risks along with practical mitigation measures. ", // [file:3]
      },
      {
        icon: "/images/services/business/approach-5.svg",
        description:
          "Present a phased implementation roadmap with timelines, milestones, and a clear feasibility recommendation. ", // [file:3]
      },
    ],
    keyBenefits: [
      " Enables informed capital allocation decisions through structured evaluation of risks, returns, and assumptions.",
      "Identifies financial, operational, and strategic risks before irreversible project commitments are made.",
      "Improves board and investor confidence through clear, data-driven feasibility assessments.",
      "Aligns project strategy with execution realities, market conditions, and financial sustainability.",
      "Supports funding discussions with credible analysis and clearly articulated project economics.",
    ],
    testimonials:
      "Feedback from decision-makers who gained clarity and confidence through structured feasibility analysis. ", // [file:3]
    CTA: {
      img: "/images/services/project-feasibility/cta.webp",
      description:
        "Before committing capital, clarity matters. Our feasibility and strategy reports support confident, data-driven project decisions. Connect with us to assess your next initiative.",
    },
    FAQ: [
      {
        q: "Who should use feasibility and strategy reports?",
        a: "Businesses, investors, and boards evaluating new projects, expansions, or large capital commitments benefit from structured feasibility analysis.", // [file:3]
      },
      {
        q: "Are reports customised per project?",
        a: "Yes, each report is built using project-specific assumptions, risks, and strategic context rather than generic templates.", // [file:3]
      },
      {
        q: "Can this support funding discussions?",
        a: "Yes, Our reports are structured to support lender, investor, and board evaluations by presenting clear assumptions, robust analysis, and a well-articulated business case, enhancing credibility in funding discussions.", // [file:3]
      },
    ],
  },

  // STARTUP ADVISORY
  {
    slug: "startup-advisory",
    title: "Startup Advisory",
    subTitle:
      "Helping early-stage companies gain clarity, structure, and investor-readiness.", // [file:3]
    heroBanner: "/images/services/Startup Advisory/hero.webp",
    shortIntro: [
      "Providing startups with strategic direction, financial discipline, and investor-focused pitch, financial model & governance structure ", // [file:3]
    ],
    serviceOverview:
      "Amicus helps early- and growth-stage startups refine business models, strengthen financial systems, and prepare for fundraising through structured advisory and hands-on execution support.", // [file:3]
    ourApproach: [
      {
        icon: "/images/services/Startup Advisory/approach-1.svg",
        description:
          "Analysing the business model to identify strengths, gaps, and opportunities for stronger market positioning.  ",
      },
      {
        icon: "/images/services/Startup Advisory/approach-2.svg",
        description:
          "Building robust financial models with revenue projections, cost structures, and performance metrics. ",
      },
      {
        icon: "/images/services/Startup Advisory/approach-3.svg",
        description:
          "Preparing investor-ready documents including pitch decks, financial packs, and due-diligence material. ",
      },
      {
        icon: "/images/services/Startup Advisory/approach-4.svg",
        description:
          " Supporting founders through fundraising discussions and investor communication strategies. ",
      },
      {
        icon: "/images/services/Startup Advisory/approach-5.svg",
        description:
          "Advising on growth plans, pricing strategies, and go-to-market models for longterm scalability. ",
      },
    ],
    keyBenefits: [
      "Greater model clarity enabling founders to articulate their business more effectively.", // [file:3]
      "Improved fundraising readiness with strong financials and investor-focused documentation.", // [file:3]
      "Better decision making supported by structured data and detailed forecasting.", // [file:3]
      "Enhanced confidence in investor meetings due to clear narratives and supporting materials.", // [file:3]
      "Stronger operational discipline with structured processes and defined growth priorities.", // [file:3]
    ],
    testimonials:
      "What Startups Say About Working with Amicus – founders share how Amicus improved clarity, discipline, and investor confidence.", // [file:3]
    CTA: {
      img: "/images/services/Startup Advisory/cta.webp",
      description:
        "Give your startup clarity, structure, and strong investor appeal. Amicus helps refine business models, build financial systems, and create investor-ready documentation. Begin your growth journey with advisory designed to strengthen decisions and long-term stability.", // [file:3]
    },
    FAQ: [
      {
        q: "How do you support startups in building sustainable business models?",
        a: "We help startups validate their value proposition, unit economics, pricing, cost structures, and go-to-market strategy. Our focus is on building scalable, cash-efficient models with clear revenue drivers, margin visibility, and disciplined capital deployment.", // [file:3]
      },
      {
        q: "How do you balance strategic guidance with practical execution support?",
        a: "We combine senior-level strategic input with on-ground execution support. While we help define strategy and priorities, we also work closely with teams to translate plans into actions, set up processes, track outcomes, and course-correct as required.", // [file:3]
      },
      {
        q: "Do you help raise funds? ",
        a: "We support startups by making them investor-ready through structured financial models, clear business narratives, and disciplined reporting, and by assisting management during investor discussions and engagements.", // [file:3]
      },
      {
        q: "Do you work with non-tech startups? ",
        a: "Yes. We work with startups across sectors, including non-tech, leveraging sector-specific insights to build sustainable business and financial frameworks. ",
      },
      {
        q: "Do you create pitch decks? ",
        a: "Yes. We help design investor-ready pitch decks that clearly articulate the business model, growth strategy, financials, and value proposition, ensuring alignment with investor expectations and funding objectives. ",
      },
    ],
  },

  // FUND ADVISORY
  {
    slug: "fund-advisory",
    title: "Fund Advisory",
    subTitle:
      "Structuring capital strategy aligned with growth stage, risk profile, and investor expectations.",
    heroBanner: "/images/services/Fund Advisory/hero.png",
    shortIntro: [
      "Structured fund advisory supporting fund houses across deal evaluation, financial diligence, valuation discipline, and post-investment monitoring. We help funds deploy capital with rigor, governance clarity, and long-term value protection.", // [file:3]
    ],
    serviceOverview:
      "Amicus provides Fund Advisory services to fund houses, AIF managers, private equity firms, venture capital funds, and family offices across the investment lifecycle. We support funds in evaluating opportunities, conducting independent financial diligence, validating valuation assumptions, and strengthening post-investment governance and performance monitoring. Our role is to act as a disciplined financial and governance partner to fund managers, enabling informed capital deployment, downside protection, and improved investment outcomes. ", // [file:3]
    subServices: [
      {
        image: "/images/services/Fund Advisory/offerings-1.png",
        title: "Financial Due Diligence (FDD)",
        description:
          "An independent assessment of financial performance, quality of earnings, sustainability of cash flows, working capital dynamics, and key financial risks, enabling disciplined, risk-adjusted investment decisions.", // [file:3]
      },
      {
        image: "/images/services/Fund Advisory/offerings-2.png",
        title: "Valuation and Deal Structuring Support",
        description:
          "Comprehensive valuation analysis supported by robust methodologies, coupled with transaction structuring advice to optimise pricing, risk allocation, return profiles, and alignment between investors and promoters.", // [file:3]
      },
      {
        image: "/images/services/Fund Advisory/offerings-3.png",
        title: "Term Sheet & SHA Advisory",
        description:
          "Commercial and financial review of term sheets and shareholder agreements, including assessment of economic terms, liquidation preferences, covenants, investor rights, governance provisions, and downside protection mechanisms to ensure alignment with fund objectives.", // [file:3]
      },
      {
        image: "/images/services/Fund Advisory/offerings-4.png",
        title: "Pre-Deal Support",
        description:
          "Support across deal evaluation, diligence coordination, data room review, and issue tracking to ensure investment risks are identified and addressed prior to capital deployment.", // [file:3]
      },
      {
        image: "/images/services/Fund Advisory/offerings-5.png",
        title: "Post-Deal Support",
        description:
          "Structured post-investment support focused on performance monitoring, governance and reporting frameworks, value-creation initiatives, and execution oversight to protect and enhance long-term investment outcomes.", // [file:3]
      },
    ],
    ourApproach: [
      {
        icon: "/images/services/Fund Advisory/approach-1.svg",
        description:
          "Detailed financial and operational review aligned with investor expectations and transaction objectives.", // [file:3]
      },
      {
        icon: "/images/services/Fund Advisory/approach-2.svg",
        description:
          "Conduct rigorous financial due diligence to validate earnings quality, cash flows, working capital, and key financial risks. ", // [file:3]
      },
      {
        icon: "/images/services/Fund Advisory/approach-3.svg",
        description:
          "Apply robust valuation frameworks to test assumptions and assess downside and upside scenarios. ", // [file:3]
      },
      {
        icon: "/images/services/Fund Advisory/approach-4.svg",
        description:
          "Review term sheets and shareholder agreements to identify economic, governance, and risk implications. ", // [file:3]
      },
      {
        icon: "/images/services/Fund Advisory/approach-4.svg",
        description:
          "Establish post-investment monitoring frameworks including MIS, KPIs, covenant tracking, and governance reviews. ", // [file:3]
      },
      {
        icon: "/images/services/Fund Advisory/approach-4.svg",
        description:
          "Provide ongoing performance and risk insights to support informed portfolio oversight. ", // [file:3]
      },
    ],
    keyBenefits: [
      "Improves investment decision quality through structured financial diligence and risk assessment processes.",
      "Strengthens investment decision-making through independent diligence, valuation discipline, and term sheet scrutiny. ",
      "Improves post-investment visibility through structured MIS and performance monitoring. ",
      "Reduces transaction uncertainty by providing clarity across pre-deal and post-deal stages. ",
      "Supports disciplined post-investment monitoring and governance oversight. ",
      "Strengthens confidence in investment outcomes through integrated advisory across the deal lifecycle. ",
    ],
    testimonials:
      "Insights from investors and promoters who achieved clarity and alignment through structured fund advisory.",
    CTA: {
      img: "/images/services/Fund Advisory/cta.png",
      description:
        "Successful investments require clarity at every stage. Our fund advisory services support informed decisions before, during, and after the deal. Connect with us to strengthen your investment process.", // [file:3]
    },
    FAQ: [
      {
        q: "Do you work with Fund  houses as well as promoters?",
        a: "Yes, We work with investor houses including AIFs, fund houses, and venture capital firms, as well as promoters and management teams. Our advisory support spans both sides of the transaction, enabling disciplined decision-making, objective evaluation, and effective alignment between investors and business owners.", // [file:3]
      },
      {
        q: "Is post-deal support included?",
        a: "Yes, we provide post-deal monitoring, governance support, and performance tracking to ensure continuity beyond transaction closure.",
      },
      {
        q: "How does Financial Due Diligence (FDD) help investors manage downside risk and protect capital?",
        a: "Our Financial Due Diligence focuses on identifying risks that directly impact capital protection, including quality of earnings, sustainability of cash flows, working capital normalization, debt and contingent liabilities, and financial control gaps. By highlighting downside risks early and providing clear, fact-based insights, FDD enables investors to make informed pricing, structuring, and risk-mitigation decisions while preserving long-term value.",
      },
      {
        q: "Can your services be engaged on a transaction-specific or retainer basis?",
        a: "Yes, Our fund advisory services can be engaged on a transaction-specific basis for individual deals or on a retainer basis for ongoing evaluation and strategic advisory, depending on the investor’s requirements.",
      },
    ],
  },

  // TRANSACTION ADVISORY
  {
    slug: "transaction-advisory",
    title: "Transaction Advisory",
    subTitle: "Managing complexity, risk, and value across transactions.", // [file:3]
    heroBanner: "/images/services/transcation-advisory/hero.webp",
    shortIntro: [
      "Strategic advisory supporting promoters across mergers and acquisitions and fund raising, with a clear focus on value protection, risk management, and execution. ",
    ],
    serviceOverview:
      "Amicus advises promoters, businesses, and investors across acquisitions, restructuring, and fund-raising transactions. Our work spans transaction strategy, financial diligence, valuation, deal structuring, and execution oversight. We support capital raising also through a curated network of AIFs, venture capital funds, private equity investors, HNIs, and strategic partners, ensuring alignment between capital expectations and business fundamentals. Through rigorous risk identification and disciplined stakeholder coordination, we help promoters execute transactions with clarity, control, and outcome certainty. ",
    subServices: [
      {
        image: "/images/services/transcation-advisory/offerings-1.webp",
        title: "Mergers and Acquisitions",
        description:
          "Advisory support across buy-side and sell-side transactions, covering target evaluation, valuation, deal structuring, negotiation support, and execution coordination to achieve strategic and value-driven outcomes.", // [file:3]
      },
      {
        image: "/images/services/transcation-advisory/offerings-2.webp",
        title: "Fund Raising",
        description:
          "Advisory support for equity and debt capital raising, including capital readiness, investor targeting, financial positioning, valuation guidance, and end-to-end transaction execution to secure funding aligned with business objectives.", // [file:3]
      },
    ],
    ourApproach: [
      {
        icon: "/images/services/transcation-advisory/approach-1.svg",
        description:
          "Clarify transaction objectives, deal rationale, capital needs, and success metrics, and assess readiness at the outset. ", // [file:3]
      },
      {
        icon: "/images/services/transcation-advisory/approach-2.svg",
        description:
          "Identify and screen potential targets, buyers, or investors aligned with sector fit, valuation expectations, and timelines. ", // [file:3]
      },
      {
        icon: "/images/services/transcation-advisory/approach-3.svg",
        description:
          "Share a curated shortlist of potential buyers, investors, or sellers with the client for review and prioritisation, finalise the outreach list based on client preferences, and coordinate introductions and initial meetings. ", // [file:3]
      },
      {
        icon: "/images/services/transcation-advisory/approach-4.svg",
        description:
          "Design optimal deal structures covering equity or debt mix, control considerations, covenants, earn-outs, and downside protection. ", // [file:3]
      },
      {
        icon: "/images/services/transcation-advisory/approach-5.svg",
        description:
          "Manage transaction execution, including diligence coordination, data room management, and negotiation support to protect value and maintain momentum. ", // [file:3]
      },
      {
        icon: "/images/services/transcation-advisory/approach-5.svg",
        description:
          "Support closing formalities and post-transaction transition to ensure intended outcomes are realised. ",
      },
    ],
    keyBenefits: [
      "Provides clear transaction strategy with guidance on expected valuation ranges and deal feasibility. ",
      "Identifies and presents well-matched buyers, investors, or target companies aligned with strategic and valuation expectations. ",
      "Supports negotiations with buyers, investors, or sellers to achieve outcomes aligned with commercial and control objectives. ",
      "Reduces execution and valuation risk through rigorous financial analysis and disciplined process management. ",
      "Ensures efficient execution and value protection through structured coordination and transaction closure support. ",
    ],
    testimonials:
      "Perspectives from clients who successfully executed transactions with structured advisory support. ", // [file:3]
    CTA: {
      img: "/images/services/transcation-advisory/cta.webp",
      description:
        "Transactions demand precision and coordination. Our advisory helps you navigate complexity with clarity and confidence. Connect with us to manage your next transaction effectively. ", // [file:3]
    },
    FAQ: [
      {
        q: "Do you support both buy-side and sell-side transactions?",
        a: "Yes, we support clients across buy-side and sell-side mandates, tailoring advisory based on transaction objectives and stakeholder dynamics.", // [file:3]
      },
      {
        q: "Can you assist in capital raising for growth businesses?",
        a: "Yes. We support capital raising for growth-stage and established businesses, covering capital strategy, investor targeting, valuation guidance, and end-to-end execution support.", // [file:3]
      },
      {
        q: "Do you handle cross-border transactions?",
        a: "Yes. We support cross-border transactions by coordinating with international advisors and counterparties, managing financial evaluation, stakeholder alignment, and execution across jurisdictions.", // [file:3]
      },
      {
        q: "What sectors do you typically advise on for M&A and fund raising?",
        a: "We advise clients across a wide range of sectors. While our transaction advisory capabilities are sector-agnostic, we have a particularly strong track record and deep domain expertise in the logistics and supply chain sector, enabling us to deliver sharper insights and more informed execution in this space.",
      },
    ],
  },

  // HUMAN CAPITAL
  {
    slug: "human-capital",
    title: "Human Capital",
    subTitle:
      "Aligning people, structure, and incentives with business strategy.", // [file:3]
    heroBanner: "/images/services/human-capital/banner.webp",
    shortIntro: [
      "Aligning people, structure, and incentives with business strategy. Human capital advisory that evaluates organisational design, leadership capability, and workforce effectiveness. ", // [file:3]
    ],
    serviceOverview:
      "Human Capital services at Amicus help organisations align people strategy with business objectives. The service focuses on performance management, leadership development, culture building, and capability enhancement to support sustainable growth and execution excellence. ", // [file:3]
    subServices: [
      {
        image: "/images/services/human-capital/offerings-1.webp",
        title: "KRA and KPI Design and Deployment",
        description:
          "We define clear roles, responsibilities, and performance measures aligned with business objectives, enabling accountability, transparency, and measurable performance across the organisation.", // [file:3]
      },
      {
        image: "/images/services/human-capital/offerings-2.webp",
        title: "Performance Management System (PMS)",
        description:
          "We design structured performance management frameworks that link individual and team performance with organisational goals, reviews, and reward mechanisms to drive consistent outcomes.", // [file:3]
      },
      {
        image: "/images/services/human-capital/offerings-3.webp",
        title: "People Development and Growth Planning",
        description:
          "We assess workforce productivity through metrics such as revenue per employee, gross profit per employee, net profit per employee, volume per employee, and cost per employee. This includes year-on-year trend analysis to identify efficiency gaps, productivity improvement opportunities, and link people performance with business growth and profitability.",
      },
      {
        image: "/images/services/human-capital/offerings-4.webp",
        title: "Learning and Development (L&D) Frameworks",
        description:
          "We create structured learning programs focused on skill enhancement, leadership development, and capability building to improve overall organisational effectiveness.",
      },
      {
        image: "/images/services/human-capital/offerings-5.webp",
        title: "Employee Engagement Survey and Culture Building",
        description:
          "We assess employee engagement and organisational culture, and support initiatives that strengthen alignment, ownership, and long-term employee commitment.",
      },
    ],
    ourApproach: [
      {
        icon: "/images/services/human-capital/approach-1.svg",
        description:
          "Define relevant people productivity metrics such as revenue per employee, gross profit per employee, net profit per employee, volume per employee, and cost per employee.",
      },
      {
        icon: "/images/services/human-capital/approach-2.svg",
        description:
          "Analyse historical trends and year-on-year movements to assess productivity improvement or decline across functions and roles.",
      },
      {
        icon: "/images/services/human-capital/approach-3.svg",
        description:
          "Benchmark productivity metrics against internal targets and industry standards to identify efficiency gaps.",
      },
      {
        icon: "/images/services/human-capital/approach-4.svg",
        description:
          "Link people productivity outcomes with business performance, cost structures, and growth objectives.",
      },
      {
        icon: "/images/services/human-capital/approach-5.svg",
        description:
          "Provide actionable recommendations to improve workforce efficiency, role design, and capacity utilisation. ",
      },
    ],
    keyBenefits: [
      "Aligns individual performance with organisational goals through clear roles and accountability frameworks.",
      " Strengthens leadership capability and succession planning to support long-term growth.",
      "Helps identify efficiency gaps and improvement opportunities at role, function, and organisation levels. ",
      "Enables data-driven decisions on hiring, capacity utilisation, and cost optimisation. ",
      "Enhances employee engagement, retention, and cultural alignment across teams.",
      "Builds organisational resilience through structured people development and capability-building initiatives.",
    ],
    testimonials:
      "Feedback from leadership teams who strengthened organisational performance through structured human capital advisory. ",
    CTA: {
      img: "/images/services/human-capital/cta.webp",
      description:
        "Strong organisations are built through people, not just strategy. Our human capital services help align performance, capability, and culture. Connect with us to strengthen your organisation. ",
    },
    FAQ: [
      {
        q: "Is this suitable for mid-sized organisations?",
        a: "Yes, our human capital services are particularly effective for growing and mid-sized organisations seeking structured performance and people frameworks.",
      },
      {
        q: "Do you customise frameworks for each organisation?",
        a: "Yes, all frameworks are designed based on organisational context, leadership style, and business objectives rather than generic templates.",
      },
      {
        q: "Can this support cultural transformation initiatives?",
        a: "Yes, engagement surveys and culture programs are designed to support behavioural change and long-term cultural alignment.",
      },
      {
        q: "Do you evaluate employee costs against industry benchmarks?",
        a: "Yes, We benchmark employee costs and productivity metrics against relevant industry standards to assess cost efficiency, identify gaps, and highlight opportunities for optimisation while ensuring alignment with business scale and performance objectives.",
      },
      {
        q: "Can this service help identify overstaffing or understaffing issues?",
        a: "Yes,  By analysing people productivity metrics such as revenue per employee, profit per employee, volume per employee, and cost per employee, and benchmarking them against industry standards and business requirements, we help identify whether the organisation is overstaffed or understaffed and recommend corrective actions aligned with growth and efficiency objectives.",
      },
    ],
  },
];
